<script>
    import { Pie } from 'vue-chartjs'
    import 'chartjs-plugin-labels'

    export default {
        name: 'DetailsBreakdownGraph',
        extends: Pie,
        props: {
            labels: {
                type: Array,
                default: () => [],
            },
            revenues: {
                type: Array,
                default: () => [],
            },
            colors: {
                type: Array,
                default: () => [],
            },
        },

        data: () => ({
            graphData: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [],
                    borderWidth: 0,
                }],
            },
            
            graphOptions: {
                plugins: {
                    labels: {
                        // render: ({ label, value, percentage }) => {
                        //   return `${label}\n${this.$options.filters.currency(value)}\n${percentage}%`
                        // },
                        position: 'outside',
                        textMargin: 6,
                        outsidePadding: 10,
                        fontFamily: '"Sansation", sans-serif',
                        fontSize: 14,
                    },
                },
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        top: 0,
                        bottom: 20,
                        left: 20,
                        right: 20,
                    },
                },
                legend: {
                    display: false,
                },
                tooltips: {
                    callbacks: {
                        title: ([{ index }], data) => {
                            return data.labels[index]
                        },
                        label: ({ index }, data) => {
                            const value = data.datasets[0].data[index]
                            return `  ${this.$options.filters.currency(value, false, false)}`
                        },
                    },
                },
            },
        }),

        watch: {
            labels () { this.formatData() },
            revenues () { this.formatData() },
            colors () { this.formatData() },
        },

        mounted () {
            this.formatData()
        },

        methods: {
            formatData () {
                this.graphData.labels = this.labels.slice()

                this.graphData.datasets[0].backgroundColor = this.colors.slice()
                this.graphData.datasets[0].data = this.revenues.slice().map(item => {
                    return Number(item) || 0
                })
                // console.log(this.graphData)
                this.renderChart(this.graphData, this.graphOptions)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/section-revenue/BreakdownGraph.vue